<div class="grid__cell grid__cell--widget grid__cell--widget-dashboard widget__bag" [dragula]='"widget-bag"'>
  <swb-slides></swb-slides>
  <swb-home-bottom-text></swb-home-bottom-text>
</div>
<div class="grid__cell grid__cell--widget grid__cell--widget-dashboard widget__bag" [dragula]='"widget-bag"'>
  <swb-hometiles></swb-hometiles>
</div>
<router-outlet></router-outlet>